import React, { useEffect, useState } from 'react';
import './FeedbackPage.css';
import feedbackImage from '../../assets/images/feedback image.png';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useNavigate } from "react-router-dom";

const FeedbackPage = () => {
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);

  const [turnstileToken, setTurnstileToken] = useState("");

  useEffect(() => {
    AOS.init({ duration: 800, once: true });

    // Load Turnstile Script
    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Render Turnstile Widget
    const interval = setInterval(() => {
      if (window.turnstile && document.getElementById("turnstile-feedback")) {
        window.turnstile.render("#turnstile-feedback", {
          sitekey: "0x4AAAAAABaVGCmmFZsKUxj3",
          theme: "light",
          callback: function (token) {
            setTurnstileToken(token);
          }
        });
        clearInterval(interval);
      }
    }, 300);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setResult("");
    setLoading(true);

    if (!API_URL) {
      setResult("❌ API URL missing. Please check Netlify env variable REACT_APP_API_URL.");
      setLoading(false);
      return;
    }

    if (!turnstileToken) {
      setResult("❌ Please verify the captcha.");
      setLoading(false);
      return;
    }

    const formData = new FormData(event.target);

    const payload = {
      name: formData.get("name"),
      email: formData.get("email"),
      q1: formData.get("q1"),
      q2: formData.get("q2"),
      q3: formData.get("q3"),
      q4: formData.get("q4"),
      q5: formData.get("q5"),
      q6: formData.get("q6"),
      q7: formData.get("q7"),
      q8: formData.get("q8"),
      q9: formData.get("q9"),
      q10: formData.get("q10"),
      q11: formData.get("q11"),
      q12: formData.get("q12"),
      q13: formData.get("q13"),
      q14: formData.get("q14"),
      q15: formData.get("q15"),
      q16: formData.get("q16"),
      q17: formData.get("q17"),
      queries: formData.get("queries"),
      turnstileToken
    };

    try {
      const response = await fetch(`${API_URL}/api/feedback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (!response.ok) {
        setResult(`❌ ${data?.error || "Something went wrong. Please try again."}`);
        setLoading(false);
        return;
      }

      setResult("✅ Feedback submitted successfully!");
      event.target.reset();

      // Redirect to Feedback Success Page
      setTimeout(() => {
        navigate("/feedback-success");
      }, 800);

    } catch (error) {
      console.error(error);
      setResult("❌ Network Error. Please try again later.");
    }

    setLoading(false);
  };

  return (
    <div className="feedback-container fade-in">
      <div className="feedback-left" data-aos="fade-right">
        <img src={feedbackImage} alt="Feedback Visual" />
      </div>

      <div className="feedback-right" data-aos="fade-left">
        <form onSubmit={handleSubmit} className="feedback-form">
          <h1 className="feedback-heading" data-aos="fade-up">Feedback Form</h1>

          {/* Name and Email */}
          <label htmlFor="name" data-aos="fade-up">Your Name:</label>
          <input type="text" id="name" name="name" placeholder="Enter Your Name" required data-aos="fade-up" />

          <label htmlFor="email" data-aos="fade-up">Your Email:</label>
          <input type="email" id="email" name="email" placeholder="your.email@example.com" required data-aos="fade-up" />

          {/* 🏠 Home Page */}
          <h2 data-aos="fade-up">🏠 Home Page</h2>
          <label data-aos="fade-up">1. Was the first impression of the Home Page visually appealing?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q1" value="Yes" required /> Yes</label>
            <label><input type="radio" name="q1" value="It's okay" /> It's okay</label>
            <label><input type="radio" name="q1" value="Needs improvement" /> Needs improvement</label>
          </div>

          <label data-aos="fade-up">2. How fast did the Home Page load for you?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q2" value="Very fast" required /> Very fast</label>
            <label><input type="radio" name="q2" value="Normal" /> Normal</label>
            <label><input type="radio" name="q2" value="Slow" /> Slow</label>
          </div>

          {/* 🧑‍💻 About Page */}
          <h2 data-aos="fade-up">🧑‍💻 About Page</h2>
          <label data-aos="fade-up">3. Did the About section give you a clear understanding of who I am?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q3" value="Yes" required /> Yes</label>
            <label><input type="radio" name="q3" value="A bit" /> A bit</label>
            <label><input type="radio" name="q3" value="Not really" /> Not really</label>
          </div>

          <label data-aos="fade-up">4. Was my introduction engaging and professional?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q4" value="Yes" required /> Yes</label>
            <label><input type="radio" name="q4" value="No" /> No</label>
            <label><input type="radio" name="q4" value="Needs improvement" /> Needs improvement</label>
          </div>

          <label data-aos="fade-up">5. What would you suggest adding or improving in the About section?</label>
          <textarea name="q5" rows="3" required data-aos="fade-up"></textarea>

          {/* 🛠️ Projects Page */}
          <h2 data-aos="fade-up">🛠️ Projects Page</h2>
          <label data-aos="fade-up">6. Were the project details easy to understand?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q6" value="Yes" required /> Yes</label>
            <label><input type="radio" name="q6" value="Somewhat" /> Somewhat</label>
            <label><input type="radio" name="q6" value="No" /> No</label>
          </div>

          <label data-aos="fade-up">7. Which project did you find most impressive? Why?</label>
          <textarea name="q7" rows="3" required data-aos="fade-up"></textarea>

          {/* 💼 Internships Page */}
          <h2 data-aos="fade-up">💼 Internships Page</h2>
          <label data-aos="fade-up">8. Did the internship experience build trust in my professional background?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q8" value="Yes" required /> Yes</label>
            <label><input type="radio" name="q8" value="Somewhat" /> Somewhat</label>
            <label><input type="radio" name="q8" value="Not really" /> Not really</label>
          </div>

          <label data-aos="fade-up">9. Was the format of the internship info easy to follow?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q9" value="Yes" required /> Yes</label>
            <label><input type="radio" name="q9" value="No" /> No</label>
          </div>

          {/* 📝 Blogs Page */}
          <h2 data-aos="fade-up">📝 Blogs Page</h2>
          <label data-aos="fade-up">10. Were the blog topics interesting and relevant to your interests?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q10" value="Yes" required /> Yes</label>
            <label><input type="radio" name="q10" value="A bit" /> A bit</label>
            <label><input type="radio" name="q10" value="Not really" /> Not really</label>
          </div>

          <label data-aos="fade-up">11. Which blog post stood out to you the most?</label>
          <textarea name="q11" rows="3" required data-aos="fade-up"></textarea>

          <label data-aos="fade-up">12. Would you like to see more technical or creative content?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q12" value="Technical" required /> Technical</label>
            <label><input type="radio" name="q12" value="Creative" /> Creative</label>
            <label><input type="radio" name="q12" value="Both" /> Both</label>
          </div>

          {/* 🧠 Skills Page */}
          <h2 data-aos="fade-up">🧠 Skills Page</h2>
          <label data-aos="fade-up">13. Was the skills section well-organized and informative?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q13" value="Yes" required /> Yes</label>
            <label><input type="radio" name="q13" value="No" /> No</label>
          </div>

          <label data-aos="fade-up">14. Do you feel the listed skills reflect strong expertise?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q14" value="Yes" required /> Yes</label>
            <label><input type="radio" name="q14" value="Somewhat" /> Somewhat</label>
            <label><input type="radio" name="q14" value="Needs more depth" /> Needs more depth</label>
          </div>

          {/* 📜 Certificates Page */}
          <h2 data-aos="fade-up">📜 Certificates Page</h2>
          <label data-aos="fade-up">15. Did the certificate list validate my knowledge and effort?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q15" value="Yes" required /> Yes</label>
            <label><input type="radio" name="q15" value="No" /> No</label>
          </div>

          <label data-aos="fade-up">16. Was the display of certificates visually clear and easy to read?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q16" value="Yes" required /> Yes</label>
            <label><input type="radio" name="q16" value="No" /> No</label>
            <label><input type="radio" name="q16" value="Could improve" /> Could improve</label>
          </div>

          {/* 📞 Contact Page */}
          <h2 data-aos="fade-up">📞 Contact Page</h2>
          <label data-aos="fade-up">17. Was it easy to find and use the contact form?</label>
          <div className="radio-group" data-aos="fade-up">
            <label><input type="radio" name="q17" value="Yes" required /> Yes</label>
            <label><input type="radio" name="q17" value="No" /> No</label>
          </div>

          <label data-aos="fade-up">Any Queries?</label>
          <textarea
            name="queries"
            rows="4"
            required
            className="round-textarea"
            data-aos="fade-up"
          ></textarea>

          {/* ✅ Turnstile Widget */}
          <div id="turnstile-feedback" className="turnstile-box" data-aos="fade-up"></div>

          <button type="submit" className="submit-button" data-aos="zoom-in" disabled={loading}>
            {loading ? "Submitting..." : "Submit Feedback"}
          </button>

          {/* Status */}
          <p style={{ marginTop: "10px", fontWeight: "600" }}>{result}</p>
        </form>
      </div>
    </div>
  );
};

export default FeedbackPage;